// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_include_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'bootstrap/dist/js/bootstrap'
import '@hotwired/turbo-rails'
import copy from 'copy-to-clipboard'
import jQuery from 'jquery'

// And also include chartkick
import Chartkick from 'chartkick'
import Chart from 'chart.js'

// This stuff is loaded on page load, used to be in initializer.js, here at least temporarily
import log from '../scripts/utils/log' // eslint-disable-line

import { PeriodSelector, TimeParser } from 'tranzito_utils_js'
import { BikehubUtilities } from '../scripts/utils/bikehub_utilities.js'
import LoadFancySelects from '../scripts/utils/load_fancy_selects.js'
import { BikehubMapping } from '../scripts/utils/mapping.js'
import { AdminBase } from '../scripts/admin/base.js'
import { BikehubPayment } from '../scripts/sections/payment.js'
import { ValetCustomerTablet } from '../scripts/admin/valet_customer_tablet.js'
import { StaffValet } from '../scripts/admin/staff_valet.js'
import { BikehubServicesDisplay } from '../scripts/sections/services_display.js'
import { BikehubLocations } from '../scripts/sections/locations.js'
import { WmataDashboard } from '../scripts/sections/wmata_dashboard.js'
import { InspectionForm } from '../scripts/sections/inspection_form.js'
import { WorkOrderForm } from '../scripts/sections/work_order_form.js'
import { BikehubVideoPlayer } from '../scripts/sections/video_player.js'
import { BikehubMembership } from '../scripts/sections/membership.js'
import initBikeSync from '../scripts/sections/bike_sync.js'
import initResetPasswordCooldown from '../scripts/sections/reset_password_cooldown.js'
import { BikehubQrCode } from '../scripts/sections/qr_code.js'
import { BikeHubFormValidator } from '../scripts/sections/form_validator.js'
import { BikehubStripeIdVerification } from '../scripts/sections/stripe_id_verification.js'

window.Chartkick = Chartkick
Chartkick.addAdapter(Chart)
// The deferred bundle sets window.Chartkick after inline chart scripts have run,
// so fire the event they wait on to render charts on a hard page load.
window.dispatchEvent(new Event('chartkick:load'))

document.addEventListener('turbo:load', function () {
  if (!window.timeParser) {
    window.timeParser = new TimeParser()
  }
  window.timeParser.localize()
  // Period selector
  if ($('#timeSelectionBtnGroup').length) {
    const periodSelector = new PeriodSelector()
    periodSelector.init()
  }

  window.bikehubUtilities = new BikehubUtilities()
  window.bikehubUtilities.init()

  // Load the page specific things
  const body = document.getElementsByTagName('body')[0]
  // payment.js and form_validator.js use this, in addition to admin
  window.inAdmin = body.classList.contains('admin-body')

  if ($('#valetCustomerTabletWrapper').length) {
    window.valetCustomerTablet = new ValetCustomerTablet()
    window.valetCustomerTablet.init()
  }

  if ($('#bikehubServicesPaneNav').length) {
    window.bikehubServicesDisplay = new BikehubServicesDisplay()
    window.bikehubServicesDisplay.init()
  }

  if ($('#videoPlayer').length) {
    window.bikehubVideoPlayer = new BikehubVideoPlayer()
    window.bikehubVideoPlayer.init()
  }

  if ($('#locationsMap').length) {
    window.bikehubMapping = new BikehubMapping()
    window.bikehubLocations = new BikehubLocations()
    window.bikehubLocations.init()
  } else if ($('#wmataDashboardMap').length) {
    window.wmataDashboard = new WmataDashboard()
    window.wmataDashboard.init()
  } else if ($('.membershipFormNoMap').length) {
    // We have membership without a map! So initialize the membership js
    // Set the membership page, below mapping init loop
    log.debug('membership without map')
    window.bikehubMembership = new BikehubMembership()
    window.bikehubMembership.init()
  }

  initBikeSync()
  initResetPasswordCooldown()

  if (window.inAdmin) {
    window.adminBase = new AdminBase()
    window.adminBase.init()
  }

  if ($('#createPurchase').length) {
    window.bikehubPayment = new BikehubPayment()
    window.bikehubPayment.init()
  }

  if ($('#qrCodeImage').length) {
    window.bikehubQrCode = new BikehubQrCode()
    window.bikehubQrCode.init()
  }

  if ($('#inspectionForm').length) {
    window.inspectionForm = new InspectionForm()
    window.inspectionForm.init()
  }

  if ($('#workOrderForm').length) {
    window.workOrderForm = new WorkOrderForm()
    window.workOrderForm.init()
  }

  if ($('#staffValetWrapper').length) {
    window.staffValet = new StaffValet()
    window.staffValet.init()
  }

  const stripeVerificationElement = $('#stripeIdentityVerification')
  if (stripeVerificationElement.length) {
    // NOTE: needs to stay named window.stripeVerification - referenced in BikehubStripeIdVerification
    window.stripeVerification = new BikehubStripeIdVerification(
      stripeVerificationElement
    )
    window.stripeVerification.init()
  }

  // Validate forms
  window.bikeHubFormValidator = new BikeHubFormValidator()
  window.bikeHubFormValidator.init()

  // And load fancy selects after everything, in case something added more fancy selects
  LoadFancySelects()
})

window.copy = copy

// Reload page after 1 hour, because turbo -> expiring times and whatever
window.setTimeout(window.location.reload.bind(window.location), 3600000)

// Because it's nice to be able to access jQuery in the console, attach it ;)
window.$ = window.jQuery = jQuery
